import clsx from 'clsx'

/** Shared visual language for text fields (Input, InputPassword, TextArea). */
export const inputBaseClasses =
  'tw-w-full tw-rounded-lg tw-px-3 tw-text-sm tw-bg-[var(--input-fill)] tw-border tw-outline-none tw-transition tw-duration-150 placeholder:tw-text-[var(--text-tertiary)]'

export const inputStateClasses = (error?: boolean) =>
  error
    ? 'tw-border-red-500 tw-text-red-600 focus:tw-border-red-500 focus:tw-ring-2 focus:tw-ring-red-500/25'
    : 'tw-border-[var(--input-border)] focus:tw-border-[var(--brand-text)] focus:tw-ring-2 focus:tw-ring-[color-mix(in_srgb,var(--brand-text)_22%,transparent)]'

export const inputClasses = (error?: boolean, extra?: string) => clsx(inputBaseClasses, inputStateClasses(error), extra)

/** Field label paired with the inputs above. */
export const labelClasses = 'tw-mb-1.5 tw-block tw-text-sm tw-font-medium tw-text-input'
